const newsCarousel = () => {
  import("slick-carousel").then(() => {
    $(".js-news-carousel").each((key, item) => {
      const $item = $(item);

      $item.slick({
        lazyLoad: "ondemand",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        appendDots: $(".js-slick-dots"),
        nextArrow: $(".js-slick-controls .slick-next"),
        prevArrow: $(".js-slick-controls .slick-prev"),
        centerMode: false,
      });

      $item.on("lazyLoaded", (e, slick, image) => {
        const parentSlide = $(image).parent(".photo");
        const src =
          window.innerWidth < 450
            ? image.attr("data-mobile")
            : image.attr("data-lazy");
        parentSlide.css("background-image", `url(${src})`).addClass("loaded");
        image.remove();
      });
    });
  });
};

const relatedArticles = () => {
  import("slick-carousel").then(() => {
    $(".js-related-articles").each((key, item) => {
      const $item = $(item);

      $item.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        appendDots: $(".js-slick-related-controls .js-slick-dots"),
        nextArrow: $(".js-slick-related-controls .slick-next"),
        prevArrow: $(".js-slick-related-controls .slick-prev"),
        centerMode: false,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              rows: 1,
              adaptiveHeight: false,
              infinite: true,
              autoplay: false,
            },
          },
        ],
      });
    });
  });
};

const single = () => {
  import("slick-carousel").then(() => {
    $(".js-slick-single-main").slick({
      asNavFor: ".js-slick-single-vertical",
      slidesToShow: 1,
      arrows: true,
      nextArrow: $(".js-slick-controls .slick-next"),
      prevArrow: $(".js-slick-controls .slick-prev"),
    });

    $(".js-slick-single-vertical").slick({
      asNavFor: ".js-slick-single-main",
      slidesToShow: 5,
      vertical: true,
      centerMode: true,
      centerPadding: 0,
      arrows: true,
      focusOnSelect: true,
      nextArrow: $(".js-slick-controls-vertical .slick-next"),
      prevArrow: $(".js-slick-controls-vertical .slick-prev"),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            vertical: false,
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            vertical: false,
            slidesToShow: 3,
          },
        },
      ],
    });
  });
};

const gallerySlider = () => {
  import("slick-carousel").then(() => {
    $(".js-gallery-slider").each((key, item) => {
      const $item = $(item);

      $item.slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        lazyLoad: "progressive",
        nextArrow: $(".gallery .js-slick-controls .slick-next"),
        prevArrow: $(".gallery .js-slick-controls .slick-prev"),
        centerMode: true,
        infinite: true,

        responsive: [
          {
            breakpoint: 2400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              infinite: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              infinite: true,
              arrows: false,
              centerMode: true,
              autoplay: true,
            },
          },
        ],
      });

      $(".js-gallery-slider").on("lazyLoaded", (e, slick, image) => {
        const parentSlide = $(image).parent(".photo");
        parentSlide
          .css("background-image", `url(${image.attr("src")})`)
          .addClass("loaded");
        image.remove();
      });

      $(".js-gallery-slider").on("beforeChange", () => {
        const $videoOn = $(".js-gallery-slider").find(".play");
        $videoOn.removeClass("play");
        $videoOn.find("iframe").attr("src", "");
      });
    });
  });
};

export { newsCarousel, relatedArticles, single, gallerySlider };
